import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  FormGroup,
  Label,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import Select from "react-select";

// actions
import {
  resetUsers,
  resetError,
  getUsers,
  activateUser,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import ProfilePicture from "../../components/Common/ProfilePicture";
import BadgesEllipsis from "../../components/Common/BadgesEllipsis";
import BadgesEllipsisSoft from "../../components/Common/BadgesEllipsisSoft";

const Users = ({ t }) => {
  let { idCompany } = useParams();
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataUser,
    dataUserActivate,
    loadingUser,
    loadingUserActivate,
    errorUser,
    successUser,
  } = useSelector((state) => state.User);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [userId, setUserId] = useState();
  const [userName, setUserName] = useState();

  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const [active, setActive] = useState();
  const [status, setStatus] = useState();

  const [companyId, setCompanyId] = useState(idCompany);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successUser && dispatch(resetUsers()) && handleFilter(),
  };

  const handleFilter = (name, email) => {
    setNameFilter(name);
    setEmailFilter(email);
    setPage(1);
    dispatch(getUsers(companyId, 1, qtdDefault, name, email, true));
  };

  const handleActivate = () => {
    dispatch(activateUser(userId, active, companyId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setUserIdName = (user) => {
    setUserId(user.id);
    setUserName(user.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(
      getUsers(companyId, value, qtdDefault, nameFilter, emailFilter, true)
    );
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataUser && dataUser.paging) {
      if (page < dataUser.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const optionsCompany = () => {
    let companies = [];

    dataUser?.form?.clients[0] &&
      dataUser.form.clients[0].forEach((company, key) =>
        companies.push({ key: key, value: company.id, label: company.name })
      );

    return companies;
  };

  useEffect(() => {
    dispatch(getUsers(null, null, null, null, null, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataUserActivate && dataUserActivate.message) {
      showToast("success", t(dataUserActivate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUser]);

  useEffect(() => {
    if (errorUser && typeof errorUser === "object") {
      errorUser.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "not found" && showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorUser) {
        showToast("error", t(errorUser));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorUser]);

  useEffect(() => {
    if (dataUser !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataUser]);

  useEffect(() => {
    if (idCompany && dataUser && dataUser.idCompany !== idCompany) {
      handleFilter();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCompany]);

  useEffect(() => {
    if (dataUser && dataUser.idCompany) {
      setCompanyId(dataUser.idCompany);
    }
    if (dataUser !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataUser]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/users"
            title={t("Dashboard")}
            breadcrumbItem={t("Users")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      if (companyId) {
                        handleFilter(values.name, values.email);
                      } else {
                        showToast("info", t("Please select a company"));
                      }
                    }}
                  >
                    <Row>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Email")}
                            id="email"
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder={t("Email") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup className="select2-container">
                          <Label className="control-label">
                            {t("Company")}
                          </Label>
                          <Select
                            classNamePrefix="select2-selection"
                            className="w-100 mb-3"
                            placeholder={t("Company") + "..."}
                            options={optionsCompany()}
                            isLoading={loadingUser ? true : false}
                            isSearchable
                            onChange={(e) => {
                              setCompanyId(e.value);
                            }}
                            noOptionsMessage={() =>
                              t("No matching records found")
                            }
                            value={optionsCompany().find(
                              (item) => item.value === companyId
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-user">
                          <Link to={`/company/${companyId}/user`}>
                            <Button
                              type="button"
                              color="success"
                              className="waves-effect waves-light w-100 mr-2 "
                              disabled={!companyId}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add User")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th>{t("Name")}</th>
                            <th>{t("Email")}</th>
                            <th>{t("Profile")}</th>
                            <th>{t("Skills")}</th>
                            <th>{t("Group")}</th>
                            <th>{t("Status")}</th>
                            <th>{t("Edit")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingUser ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataUser &&
                            dataUser.users &&
                            dataUser.users.length > 0 ? (
                            dataUser.users.map((user, key) => (
                              <tr key={key}>
                                <td>
                                  <ProfilePicture
                                    name={user.name}
                                    src={user.url_avatar}
                                  />
                                </td>
                                <td>{user.name}</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="text-body font-weight-bold"
                                  >
                                    {user.email}
                                  </Link>
                                </td>
                                <td>
                                  {user.profiles.map((profile) => profile.name)}
                                </td>
                                <td>
                                  <BadgesEllipsisSoft
                                    objItems={user.skills}
                                    sizePx={150}
                                  />
                                </td>
                                <td>
                                  {
                                    <BadgesEllipsis
                                      objItems={user.groups}
                                      sizePx={150}
                                    />
                                  }
                                </td>
                                <td>
                                  <div
                                    className="custom-control custom-switch"
                                    dir="ltr"
                                  >
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id={"customSwitch" + user.id}
                                      readOnly
                                      checked={user.active}
                                      onClick={() => {
                                        setUserIdName(user);
                                        toggleModal();
                                        setStatus(
                                          user.active
                                            ? t("deactivate")
                                            : t("activate")
                                        );
                                        setActive({ active: !user.active });
                                      }}
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor={"customSwitch" + user.id}
                                    >
                                      {user.active
                                        ? t("Active")
                                        : t("Inactive")}
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <Link
                                    to={`/company/${companyId}/user/${user.id}`}
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id="edittooltip"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target="edittooltip"
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingUserActivate}>
                        <div className="modal-body font-size-18 text-center">
                          {`${t("Do you want to")} ${status}`}
                          <strong> {userName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingUserActivate ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (userId) handleActivate();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataUser && dataUser.paging && dataUser.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataUser &&
                        dataUser.paging &&
                        dataUser.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Users);
